import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindows, faLinux } from '@fortawesome/free-brands-svg-icons';
import { faLaptop } from '@fortawesome/free-solid-svg-icons';

export default function DriveInfoCard({ device }) {
  const theme = useTheme();
  const isWindows = device.os?.toLowerCase().includes('windows');
  const osIcon = isWindows ? faWindows : faLinux;
  const osIconColor = isWindows ? '#00B0FF' : theme.palette.text.secondary;

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
      gap={2}
      p={{ xs: 2, md: 3 }}
      width="100%"
      bgcolor={theme.palette.background.paper}
      boxShadow={theme.shadows[2]}
      borderRadius={2}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <FontAwesomeIcon
          icon={faLaptop}
          style={{ color: theme.palette.text.secondary, fontSize: 24 }}
        />
        <Box>
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 700,
              color: theme.palette.text.primary,
            }}
          >
            {device.name || 'Unknown Device'}
          </Typography>
          <Typography
            sx={{
              fontSize: 14,
              color: theme.palette.text.secondary,
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <FontAwesomeIcon icon={osIcon} style={{ color: osIconColor }} />
            {device.os || 'Unknown OS'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
